import { stringNotEmpty, Theme } from "@equiem/web-ng-lib";
import React, { useContext } from "react";
import { AiOutlineUser } from "react-icons/ai";

interface Props {
  avatar?: string | null;
}

export const CommentAvatar: React.FC<Props> = ({ avatar }) => {
  const theme = useContext(Theme);

  return (
    <div className="comment-avatar">
      {stringNotEmpty(avatar) ? (
        <img src={avatar} className="rounded-circle w-100" />
      ) : (
        <div className="bg-white rounded rounded-circle d-inline-block p-md-1 text-secondary">
          <AiOutlineUser size="30" />
        </div>
      )}
      <style jsx>{`
        .comment-avatar {
          width: 30px;
        }

        @media screen and (min-width: ${theme.breakpoints.md}px) {
          .comment-avatar {
            width: 40px;
          }
        }
      `}</style>
    </div>
  );
}
